var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-form"},[(_vm.model.label)?_c('div',{staticClass:"form-label desc"},[_vm._v(_vm._s(_vm.model.label))]):_vm._e(),(_vm.model.content)?_c('div',{staticClass:"form-content",style:(_vm.model.style),domProps:{"innerHTML":_vm._s(_vm.model.content)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }